<template>
    <div class="business">
        <toast-message :message="errmsg" type="error" :isToastEnable="toast" @close="(val) => toast = val" />
        <div>
            <div class="row margin-t-s">
                <div class="datatable-outer-container">
                    <data-table 
                        :columns="exemptTableColumns" 
                        :tableData="empFnfPayslipData"
                        :showinrow="true" 
                        :withForm="false"
                        :showhistory="false" :showdelete="false" :showedit="false">
                        <template v-slot:rowcontent="slotprops">
                            <button
                                class="fnfbtn"
                                v-if="slotprops.value.column.key == 'download'"
                                @click="downloadFnfPayslip(slotprops.value.record)"
                            >Download</button>
                        </template>
                    </data-table>
                </div>
            </div>
            <footer>
                <popup-bottom-container>
                    <template slot="end">
                        <btn-grp class="form-button">
                            <btn text="Cancel" type="secondary" @click="goBack" />
                            <!-- <btn text="Save" type="primary" @click="submitData" /> -->
                        </btn-grp>
                    </template>
                </popup-bottom-container>
            </footer>
        </div>
    </div>
</template>
  
<script>
import { updateLocale } from "moment";
import { mapState, mapActions, mapGetters } from "vuex";
const crypto = require("crypto");

export default {
    name: "fnfPayslip",
    props: {
        FnfPayslipData: {
            type: Object
        }
    },
    data() {
        return {
            errmsg: "",
            data1: [],
            toast: false,
            showSuccessMsg: false,
            empFnfPayslipData: [],
            exemptTableColumns: [
                {
                    label: "Code",
                    key: "empCode"
                },
                {
                    label: "Name",
                    key: "empName"
                },
                {
                    label: "Month",
                    key: "paymentMonth"
                },
                {
                    label: "Year",
                    key: "paymentYear"
                },
                {
                    label: "",
                    key: "download"
                },
            ],
        };
    },
    computed: {
        le_id() {
            return this.$store.getters["onboard/legal_entities/legal_entity_ID"](
                this.$route.params.entity_index
            );
        },
    },

    mounted() {
        // console.log(this.FnfPayslipData);
        // this.showSuccessMsg = false;
        this.getFnfPayslipData();    
    },

    activated() {
        // this.toast = false;
        // this.errmsg = "";
        // this.showSuccessMsg = false;
        this.getFnfPayslipData();
    },

    methods: {
        ...mapActions({
            getOrgLeList: "onboard/organization/getOrgLeIdList",
            act_fnf_payslip_pop_up: 'dashboard/organisation/processfnf/fnfPayslipsPopup',
            act_download_fnfpayslip: 'dashboard/organisation/processfnf/downloadFnfPayslip',

        }),

        async downloadFnfPayslip(item){
                let obj={
                    Id:item.Id
                }
                // console.log(obj);
                let data = await this.encryptData(obj);
                // console.log(data, 'data');
                let res = await this.act_download_fnfpayslip(data);
                let apiResponse = JSON.parse(await this.decrypt(res.data));
                if (apiResponse && apiResponse.data && apiResponse.success) {
                // let test = apiResponse.data.pdfPreSignedUrl;
                const url = apiResponse.data.pdfPreSignedUrl;
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Payslip.pdf"); //or any other extension
                document.body.appendChild(link);
                link.click();
                } else {
                this.toast = true;
                // console.log(apiResponse, 'api');
                this.errmsg = apiResponse.message
                }
        },
        async forceDownload(element,) {
                try {
                let url = element;
                const response = await fetch(url);
                const blob = await response.blob();
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.setAttribute("download", "");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(link.href);
            } catch (error) {
                console.error("Error during download:", error);
            }
    },

        async getFnfPayslipData(){
            try {
                let obj = {
                    legalEntityId: this.FnfPayslipData.le_id,
                    empCode: this.FnfPayslipData.code, // PL_3042
                }
                // console.log(obj);
                let data = await this.encryptData(obj);
                // console.log(data, 'data');
                let res = await this.act_fnf_payslip_pop_up(data)
                // console.log(res, 'res');
                let apiResponse = JSON.parse(await this.decrypt(res.data));
                // console.log(apiResponse, 'api');
                if (apiResponse && apiResponse.data && apiResponse.success) {
                    this.empFnfPayslipData = apiResponse.data
                } else {
                this.toast = true;
                // console.log(apiResponse, 'api');
                this.errmsg = apiResponse.message
                }
            } catch (error) {
                this.toast = true;
                this.errmsg = error;
            }

        },

        async encryptData(payload) {
            try {
                const iv = crypto.randomBytes(8).toString('hex')
                const key = process.env.VUE_APP_PAYSLIP_SECRET;
                const cipher = crypto.createCipheriv('aes-256-cbc', key, iv);
                let encryptedText = Buffer.concat([
                    cipher.update(JSON.stringify(payload)),
                    cipher.final()
                ]);
                return {
                    iv: iv.toString(),
                    encryptedPacket: encryptedText.toString('base64')
                }
            } catch (err) {
                throw err;
            }
        },

        async decrypt(payload) {
            try {
                const key = process.env.VUE_APP_PAYSLIP_SECRET;
                const decipher = crypto.createDecipheriv('aes-256-cbc', key, payload.iv);
                const decrypted = Buffer.concat([decipher.update(payload.encryptedPacket, 'base64'), decipher.final()]);
                return decrypted.toString();
            } catch (error) {
                // console.log(error)
            }
        },
        // Add here code for cancel button to hide popup By Bhushan 
        goBack() {
            this.$emit('back');
        },
        
    },
};
</script>
  
<style lang="scss" scoped>
// .business {
//   width: 100%;
//   height: 100%;
// }

// .business .top-bar {
//   height: auto;
//   padding: 20px;
//   background-color: #34c0be;
//   display: flex;
// }

.search-container {
    width: auto;
}

.border-right-side {
    border-right: 2px solid #dddddd;
    padding-right: 0px;
}

.line-color {
    border-right: 2px solid #dddddd;
}

.img-float-right-side {
    float: right;
}

.tl-checkbox .container {
    font-size: 0.9rem;
}

.text-right-side {
    float: right;
}

.section-table {
    padding: 24px 0px;
}

.datatable-outer-container {
    width: 100%;
}

.datatable-outer-container table.datatable {
    width: 100%;
    border-collapse: collapse;
    margin: 0 auto;
    font-family: Montserrat;
    margin-bottom: 4px;
}

.datatable-outer-container table.datatable .header-row {
    background-color: white;
    height: 54px;
}

.datatable-outer-container table.datatable .header-row th {
    background-color: #f0f1f5;
    border-bottom: 1px solid #34c0be;
    padding: 6px 20px;
}

.datatable-outer-container table.datatable .header-row th .tl-checkbox {
    text-align: center;
}

.datatable-outer-container table.datatable .inactiveCols {
    opacity: 0.03;
    background-color: #a2a1a1;
}

.datatable-outer-container table.datatable .Editdeleteheader {
    background-color: #ffffff;
    -webkit-box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);
    box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);
}

.datatable-outer-container table.datatable .Editdeleteheader th {
    padding: 0 8px;
}

.datatable-outer-container table.datatable .Editdeleteheader th span {
    border-right: 1px solid #ececec;
    padding: 0px 18px 0px 15px;
    display: inline-block;
    vertical-align: middle;
}

.datatable-outer-container table.datatable .Editdeleteheader th span:first-child {
    padding: 10px 10px 7px 10px;
}

.datatable-outer-container table.datatable .Editdeleteheader th:last-of-type {
    text-align: right;
}

.datatable-outer-container table.datatable .Editdeleteheader th:last-of-type span {
    border-right: none;
    font-weight: 400;
    font-style: italic;
    position: relative;
}

.datatable-outer-container table.datatable .Editdeleteheader th:last-of-type span i {
    position: absolute;
    right: 10px;
    top: 2px;
}

.datatable-outer-container table.datatable .record-row {
    height: 60px;
    border-bottom: none;
}

.datatable-outer-container table.datatable .record-row:nth-child(odd) {
    background-color: #fff;
}

.datatable-outer-container table.datatable .record-row.selectedRecord {
    background-color: #E9F9F8;
    opacity: 0.9;
}

.datatable-outer-container table.datatable .record-row td {
    padding: 6px 8px;
    color: #646464;
    font-weight: 500;
}

.datatable-outer-container table.datatable .record-row td .tl-checkbox {
    text-align: center;
}

.datatable-outer-container table.datatable .record-row .actions {
    width: 10%;
    padding: 10px;
}

.datatable-outer-container table.datatable .record-row .row-item {
    padding: 6px 20px;
}

.datatable-outer-container table.datatable .record-row .row-item p {
    width: 100%;
    margin-bottom: 0px;
}

.datatable-outer-container table.datatable .record-row .action-img {
    display: inline-block;
    cursor: pointer;
    opacity: 0;
}

.datatable-outer-container table.datatable .record-row:hover .action-img {
    opacity: 1;
}

.inputbox {
    width: 149px;
    height: 35px;
    // width: 30%;
    padding: 4px;
    border: 1px solid #c6c9c8;
    border-radius: 4px;

    &:focus {
        outline: none;
        border: 2px solid #37c6c0;
    }
}

.inputbox-large {
    height: 35px;
    width: 30%;
    padding: 4px;
    border: 1px solid #c6c9c8;
    border-radius: 4px;

    &:focus {
        outline: none;
        border: 2px solid #37c6c0;
    }
}
</style>
  